import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, Mail, Phone } from "lucide-react";
import { SITE } from "../data/site";
import { Reveal } from "./Reveal";

export default function CtaSection({
  heading = "Let's Build Something Great Together.",
  sub = "From maintenance outages and facility improvements to complex industrial construction, our team is ready to help.",
}) {
  return (
    <section className="relative overflow-hidden bg-gig-black" data-testid="cta-section">
      <motion.img
        src={SITE.heroImage}
        alt=""
        className="absolute inset-0 h-full w-full object-cover opacity-40"
        animate={{ scale: [1, 1.05, 1] }}
        transition={{ duration: 30, repeat: Infinity, ease: "easeInOut" }}
        loading="lazy"
        width="1920"
        height="960"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-gig-black via-gig-black/80 to-gig-navy/60" aria-hidden="true" />
      <div className="relative mx-auto max-w-[1440px] px-5 py-24 lg:px-10 lg:py-32">
        <Reveal>
          <p className="eyebrow">Start a Conversation</p>
          <h2 className="mt-5 max-w-3xl font-condensed text-4xl sm:text-5xl lg:text-6xl font-bold uppercase leading-[0.95] text-white">
            {heading}
          </h2>
          <p className="mt-5 max-w-xl text-base md:text-lg text-white/75">{sub}</p>
          <div className="mt-9 flex flex-wrap items-center gap-4">
            <Link to="/contact" className="btn-primary" data-testid="cta-start-project">
              Start a Project <ArrowRight className="btn-arrow h-4 w-4" aria-hidden="true" />
            </Link>
            <a href={SITE.phoneHref} className="btn-outline-light" data-testid="cta-call">
              <Phone className="h-4 w-4" aria-hidden="true" /> Call {SITE.phone}
            </a>
            <a
              href={`mailto:${SITE.email}`}
              className="inline-flex items-center gap-2 text-white/80 underline decoration-gig-red decoration-2 underline-offset-4 hover:text-white transition-colors"
              data-testid="cta-email"
            >
              <Mail className="h-4 w-4" aria-hidden="true" /> {SITE.email}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
